export const convertToTitleCase = (str: string) =>
  str?.toLowerCase().replace(/(?:^|\s)\w/g, (match) => match.toUpperCase());
